'use client';
import React from 'react';
import Container from '@src/components/Shared/Container';
import SectionHeader from '@src/components/Shared/SectionHeader';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import RenderButtons from '@src/components/Shared/RenderButtons';
import InlineSVG from '@src/components/Shared/InlineSVG';
import useHumanTrakTilesAnimate from './useHumanTrakTilesAnimate';
import { HumanTrakVideoPropTypes } from './HumanTrakVideo.types';

export default function HumanTrakVideo({ data, id }: HumanTrakVideoPropTypes) {
  const { containerRef, videoRef } = useHumanTrakTilesAnimate();
  return (
    <div id={id} className=''>
      <Container className='pb-[7.4rem] pt-[3.4rem] md:flex md:flex-col lg:pt-[7.4rem]'>
        <SectionHeader
          className=' z-101 mb-[6.4rem] lg:mb-[9.4rem]'
          pretitle={data?.preTitle}
          title={data?.title}
          titleClassName='mb-[3rem] text-[2.8rem] md:text-[4.8rem] leading-[3.2rem] md:leading-[4.6rem] font-light  xl:leading-[5rem] max-w-[45rem]'
          align='center'
        >
          <>
            <RenderBodyCopy bodyCopy={data?.bodyCopy?.json?.content} />
            <RenderButtons className='md:justify-center' items={data?.buttonCollection?.items} />
          </>
        </SectionHeader>

        <div ref={containerRef} className='relative mt-[3rem] md:mt-[-5rem] xl:mt-[-12rem]'>
          <video
            ref={videoRef}
            src={data?.mediaPrimary?.url}
            className='lg:mb-[unset]'
            muted
            autoPlay
            playsInline
          />
          {/* Camera and tripod description desktop and mobile */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[0]?.media?.url}
            className='humantrak-tile-animate absolute! left-[-2%] top-[52%] hidden w-[22rem] opacity-0 lg:block 2xl:w-[30rem]'
            renderAt={['desktop']}
          />
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[1]?.media?.url}
            className='humantrak-tile-animate absolute! left-[-4%] top-[14%] w-[10rem] opacity-0 xsm:left-[2%] xsm:top-[16%] sm:left-[2%] sm:w-[12rem] md:left-[4%] md:top-[18%] md:w-[15rem] lg:hidden'
            renderAt={['tablet', 'mobile']}
          />
          {/* Hard case travel description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[2]?.media?.url}
            className='humantrak-tile-animate absolute! left-[59%] top-[30%] w-[15rem] opacity-0 sm:w-[17rem] md:w-xs lg:left-[60%] lg:top-[33%] lg:w-md 2xl:w-xl'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
          {/* Custom laptop description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[3]?.media?.url}
            className='humantrak-tile-animate absolute! left-[70%] top-[38%] w-[12rem] opacity-0 sm:left-[73%] sm:top-[39%] sm:w-[14.5rem] md:left-[73%] md:top-[40%] md:w-[19rem] lg:left-[75%] lg:top-[41%] lg:w-[26rem] 2xl:w-[34rem] 3xl:top-[44%]'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
          {/* Wireless keyboard description */}
          <InlineSVG
            src={data?.extraAssetsCollection?.items?.[4]?.media?.url}
            className='humantrak-tile-animate absolute! left-[60%] top-[85%] w-[9rem] opacity-0 sm:w-[11rem] md:w-[15rem]  lg:top-[86%] lg:w-xs 2xl:left-[65%] 2xl:w-[25rem]'
            renderAt={['desktop', 'tablet', 'mobile']}
          />
        </div>
      </Container>
    </div>
  );
}
